import { apiRequest } from './api';

export type DispositivoRedeTipo =
  | 'switch'
  | 'servidor'
  | 'roteador'
  | 'radio_ap'
  | 'radio_station'
  | 'cliente'
  | 'servicos'
  | 'energia';

export type DispositivoRedeMonitorStatus = 'online' | 'offline' | 'unknown';

export type DispositivoRedeModoMonitoramento = 'ping_ip' | 'status_conexao';

export interface DispositivoRedeContratoServico {
  id: number;
  tipo: string;
  status: string;
  endereco_ip?: string | null;
  usuario_pppoe?: string | null;
  contrato_id: number;
  plano?: { nome: string };
  contrato?: {
    id: number;
    titulo: string;
    cliente_id: number;
    cliente?: { id: number; nome: string };
  };
}

export interface DispositivoRede {
  id: number;
  nome: string;
  tipo: DispositivoRedeTipo;
  modo_monitoramento?: DispositivoRedeModoMonitoramento | null;
  monitorar_ate?: string | null;
  endereco_ip?: string | null;
  contrato_servico_id?: number | null;
  ativo: boolean;
  monitor_status: DispositivoRedeMonitorStatus;
  monitor_latencia_ms?: number | null;
  monitor_ultimo_ping_em?: string | null;
  monitor_ultimo_online_em?: string | null;
  monitor_ultimo_offline_em?: string | null;
  contrato_servico?: DispositivoRedeContratoServico | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface DispositivoRedeFormData {
  nome: string;
  tipo: DispositivoRedeTipo;
  modo_monitoramento?: DispositivoRedeModoMonitoramento;
  monitorar_ate?: string | null;
  endereco_ip?: string;
  contrato_servico_id?: number | null;
  ativo?: boolean;
}

export interface DispositivoRedeFilters {
  search?: string;
  tipo?: DispositivoRedeTipo | '';
  ativo?: 'true' | 'false' | '';
}

export const DISPOSITIVO_REDE_TIPOS: { value: DispositivoRedeTipo; label: string }[] = [
  { value: 'switch', label: 'Switch' },
  { value: 'servidor', label: 'Servidor' },
  { value: 'roteador', label: 'Roteador' },
  { value: 'radio_ap', label: 'Rádio AP' },
  { value: 'radio_station', label: 'Rádio Station' },
  { value: 'cliente', label: 'Cliente' },
  { value: 'servicos', label: 'Serviços externos' },
  { value: 'energia', label: 'Energia' },
];

export const dispositivoRedeService = {
  list: async (filters?: DispositivoRedeFilters): Promise<DispositivoRede[]> => {
    const params = new URLSearchParams();
    if (filters?.search) params.append('search', filters.search);
    if (filters?.tipo) params.append('tipo', filters.tipo);
    if (filters?.ativo) params.append('ativo', filters.ativo);

    const query = params.toString();
    const response = await apiRequest.get<DispositivoRede[]>(
      `/monitoramento/dispositivos-rede${query ? `?${query}` : ''}`
    );
    return response.data || [];
  },

  getById: async (id: number): Promise<DispositivoRede> => {
    const response = await apiRequest.get<DispositivoRede>(`/monitoramento/dispositivos-rede/${id}`);
    return response.data!;
  },

  create: async (data: DispositivoRedeFormData): Promise<DispositivoRede> => {
    const response = await apiRequest.post<DispositivoRede>('/monitoramento/dispositivos-rede', data);
    return response.data!;
  },

  update: async (id: number, data: Partial<DispositivoRedeFormData>): Promise<DispositivoRede> => {
    const response = await apiRequest.put<DispositivoRede>(
      `/monitoramento/dispositivos-rede/${id}`,
      data
    );
    return response.data!;
  },

  remove: async (id: number): Promise<void> => {
    await apiRequest.delete(`/monitoramento/dispositivos-rede/${id}`);
  },

  searchServicos: async (q: string): Promise<DispositivoRedeContratoServico[]> => {
    const response = await apiRequest.get<DispositivoRedeContratoServico[]>(
      `/monitoramento/dispositivos-rede/servicos-busca?q=${encodeURIComponent(q)}`
    );
    return response.data || [];
  },
};
